import { Type } from 'typebox';
export function createFallbackStringEnumCodec(values, fallbackValue) {
    const allowedValues = Object.values(values);
    return Type.Codec(Type.String())
        .Decode((value) => {
        const matchedValue = allowedValues.find((candidate) => candidate === value);
        return matchedValue ?? fallbackValue;
    })
        .Encode((value) => value);
}
